import App from './App';
import mixin from './mixin/mixin';
import router from './router';

Vue.mixin(mixin);

window.app = new Vue({
	router,
	render: h => h(App)
}).$mount('#app');